// SPDX-FileCopyrightText: 2024 Sequent Tech <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql } from "@apollo/client";
export var GET_USER_TEMPLATE = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    mutation GetUserTemplate($template_type: String!) {\n        get_user_template(template_type: $template_type) {\n            template_hbs\n            extra_config\n        }\n    }\n"], ["\n    mutation GetUserTemplate($template_type: String!) {\n        get_user_template(template_type: $template_type) {\n            template_hbs\n            extra_config\n        }\n    }\n"])));
var templateObject_1;
